<div id="sectionToPrint">
  <div class="inner-info mb-3">
    <h3 class="uppercase">Informação do Pedido</h3>
    <hr>
    <div class="row">
      <app-icone-descricao
        [Icone]="'fas fa-user-tie'"
        [Titulo]="'Cliente:'"
        [Descricao]="pedido?.nome">
      </app-icone-descricao>
      <app-icone-descricao
        [Icone]="'fas fa-boxes'"
        [Titulo]="'Número do Lote:'"
        [Descricao]="pedido?.loteId">
      </app-icone-descricao>
      <app-icone-descricao
        [Icone]="'fas fa-clipboard-check'"
        [Titulo]="'NRT:'"
        [Descricao]="pedido?.pedidoId">
      </app-icone-descricao>
      <app-icone-descricao
        [Icone]="'fas fa-file-alt'"
        [Titulo]="'Número de documento:'"
        [Descricao]="pedido?.documento">
      </app-icone-descricao>
      <app-icone-descricao
        [Icone]="'fas fa-paper-plane'"
        [Titulo]="'Serviço:'"
        [Descricao]="pedido?.nomeServico">
      </app-icone-descricao>
      <app-icone-descricao
        [Icone]="'fas fa-calendar-alt'"
        [Titulo]="'Entregar até:'"
        [Descricao]="pedido?.dtEntregaPrevista">
      </app-icone-descricao>
    </div>
  </div>
  <div class="mb-3">
    <app-bloco-remetente-destinatario-interno [Pedido]="pedido"></app-bloco-remetente-destinatario-interno>
  </div>
  <div class="bloco-unico mb-3">
    <h3 class="uppercase">Rastreamento</h3>
    <hr>
    <!-- <app-etapa-rastreamento [Pedido]="pedido?.tracking"></app-etapa-rastreamento> -->
    <app-bloco-historico-consulta [PedidoId]="pedido?.pedidoId"></app-bloco-historico-consulta>
  </div>

  <div class="mb-3 page-break">
    <app-bloco-rat [Pedido]="pedido"></app-bloco-rat>
  </div>

  <div class="mb-3 comprovantes">
    <app-bloco-comprovante [Pedido]="pedido" [Exibir]="false"></app-bloco-comprovante>
  </div>
</div>

<div id="imprimir" class="p-3">
  <div class="d-flex justify-content-center py-3">
    <button mat-flat-button class="btn btn-success no-print" (click)="imprimir('sectionToPrint')">
      IMPRIMIR <i class="fas fa-print"></i>
    </button>
  </div>
</div>
